import { BadgePDPModel } from 'interfaces/database';
import ApiService from 'services/ApiService';

class BadgePDPService extends ApiService<BadgePDPModel> {
	constructor() {
		super('badgepdp');
	}
}

export default new BadgePDPService();
